import { IDCodesLookupLayout, IDTaxProfileLookupLayout, IDFuelAndMiscTaxLookupLayout } from "../../../common/lookups/Layouts/IdLayouts";
import { ABPopupMessageLayout } from "../../../common/lookups/Layouts/ABLayouts";

const SearchLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "TaxCode",
                "tableName": "IDTAXHEADER",
                "label": "Tax Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description1",
                "tableName": "IDTAXHEADER",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Description2",
                "tableName": "IDTAXHEADER",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Status",
                "tableName": "IDTAXHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "ApplyOnTax1",
                "tableName": "IDTAXHEADER",
                "label": "Apply on Tax 1",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Comment",
                "tableName": "IDTAXHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PopupMessage",
                "tableName": "IDTAXHEADER",
                "label": "Popup Message",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ProfileCode",
                "tableName": "IDTAXHEADER",
                "label": "Profile Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IDTAXHEADER",
                "label": "Code 1",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C3' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IDTAXHEADER",
                "label": "Code 2",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C4' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IDTAXHEADER",
                "label": "Code 3",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C5' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IDTAXHEADER",
                "label": "Code 4",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C6' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IDTAXHEADER",
                "label": "Code 5",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C7' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IDTAXHEADER",
                "label": "Code 6",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C8' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IDTAXHEADER",
                "label": "Code 7",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C9' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IDTAXHEADER",
                "label": "Code 8",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'D0' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IDTAXHEADER",
                "label": "Code 9",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'D1' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IDTAXHEADER",
                "label": "Code 10",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'D2' }),
                "required": false,
                "visible": false,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedDate1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IDTAXHEADER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IDTAXHEADER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IDTAXHEADER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IDTAXHEADER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IDTAXHEADER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IDTAXHEADER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IDTAXHEADER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IDTAXHEADER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IDTAXHEADER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IDTAXHEADER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 1",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 2",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 3",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 4",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 5",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 6",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 7",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 8",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 9",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 10",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IDTAXHEADER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IDTAXHEADER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IDTAXHEADER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IDTAXHEADER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IDTAXHEADER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IDTAXHEADER",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IDTAXHEADER",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IDTAXHEADER",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IDTAXHEADER",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IDTAXHEADER",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedComment",
                "localizedField": "USERDEFINEDCOMMENT",
                "tableName": "IDTAXHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "CreationDateTime",
                "tableName": "IDTAXHEADER",
                "label": "Creation Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreationUserId",
                "tableName": "IDTAXHEADER",
                "label": "Creation User",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "IDTAXHEADER",
                "label": "Last Update Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateUserId",
                "tableName": "IDTAXHEADER",
                "label": "Last Update User",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CompanyId",
                "tableName": "IDTAXHEADER",
                "label": "Company",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "KeySequence",
                "tableName": "IDTAXHEADER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    },
];

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "tableName": "IDTAXHEADER",
                "localizedField": "Keysequence",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RProfile",
                "tableName": "IDTAXHEADER",
                "label": "Profile",
                "type": "lookup",
                "layout": IDTaxProfileLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TaxCode",
                "tableName": "IDTAXHEADER",
                "label": "Tax Code",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "Description1",
                "tableName": "IDTAXHEADER",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength": 40,
            },
            {
                "name": "Description2",
                "tableName": "IDTAXHEADER",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "maxLength": 40,
            },
            {
                "name": "Status",
                "tableName": "IDTAXHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ApplyOnTax1",
                "tableName": "IDTAXHEADER",
                "label": "Apply on Tax 1",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RIdFuelAndMiscTaxes",
                "tableName": "IDTAXHEADER",
                "label": "State",
                "type": "lookup",
                "layout": IDFuelAndMiscTaxLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Comment",
                "tableName": "IDTAXHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PopupMessage",
                "tableName": "IDTAXHEADER",
                "label": "Popup Message",
                "type": "lookup",
                "layout": ABPopupMessageLayout({ tableName: 'IDTAXHEADER' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "AsOfDate",
                "tableName": "IDTAXHEADER",
                "label": "As Of Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "TotalRate",
                "tableName": "IDTAXHEADER",
                "label": "Total % Rate",
                "type": "number",
                "format": "#0.######",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                "readOnly": true,
            }
        ]
    }
];

const CodesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedCode1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IDTAXHEADER",
                "label": "Code 1",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C3' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IDTAXHEADER",
                "label": "Code 2",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C4' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IDTAXHEADER",
                "label": "Code 3",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C5' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IDTAXHEADER",
                "label": "Code 4",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C6' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IDTAXHEADER",
                "label": "Code 5",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C7' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IDTAXHEADER",
                "label": "Code 6",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C8' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IDTAXHEADER",
                "label": "Code 7",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'C9' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IDTAXHEADER",
                "label": "Code 8",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'D0' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IDTAXHEADER",
                "label": "Code 9",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'D1' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "UserDefinedCode10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IDTAXHEADER",
                "label": "Code 10",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: 'D2' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedDate1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IDTAXHEADER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IDTAXHEADER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IDTAXHEADER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IDTAXHEADER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IDTAXHEADER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IDTAXHEADER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IDTAXHEADER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IDTAXHEADER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IDTAXHEADER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IDTAXHEADER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedQuantity1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 1",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 2",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 3",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 4",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 5",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 6",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 7",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 8",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 9",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IDTAXHEADER",
                "label": "Quantity 10",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

const ReferencesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedReference1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IDTAXHEADER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IDTAXHEADER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IDTAXHEADER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IDTAXHEADER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IDTAXHEADER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IDTAXHEADER",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IDTAXHEADER",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IDTAXHEADER",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IDTAXHEADER",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IDTAXHEADER",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedComment",
                "localizedField": "USERDEFINEDCOMMENT",
                "tableName": "IDTAXHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export { SearchLayout, PrimaryLayout, CodesLayout, ReferencesLayout };
